import React, { useMemo, useState } from "react";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import { headerStyle } from "views/pages/manage/edpOps/stockManagement/stockTxns/style";
import Filters from "./Filters";
import { dummyRows, inputFilters } from "./constant";
import ListComponent from "./ListComponent";
import { Card } from "@mui/material";
import { useApprovalListing } from "./hooks";
import ContactDetailDialog from "./ContactDetailDialog";
import ALoader from "views/pages/manage/common/a-loader";
import ReminderDialog from "./ReminderDialog";

const TABS = [
  { key: "FOLO", label: "Follow up (FOLO)" },
  { key: "TO_BE_FOLLOW_UP", label: "To Be Follow Up (APPL/MATR)" },
];

const OutstandingListingWrapper = ({
  userPermissions
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);



  const {
    dropdownData,
    globalFilter,
    paginationInfo,
    outstandingList,
    selectedTab,
    loading,
    showModelInfo,
    setGlobalFilter,
    tabStyle,
    bottomBorder,

    setShowModelInfo,

    getOutstandingList,
    updateRemindersndRemarks,
    getStudentContactDetails
  } = useApprovalListing({});

  const handleContactDetailsOpen = (row) => {
    // setSelectedRow(row);
    getStudentContactDetails(row.psid, setShowModelInfo);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditingRow(null);
  };

  const handleSaveRemarks = async (data) => {
    if (!editingRow) return;
    // TODO: call backend save handler here if available
    await updateRemindersndRemarks({ ...data, applicationId: editingRow.applicationId , id: editingRow.id });
    handleCloseDialog();
  };

  return (<>
    {loading && <ALoader position={"fixed"} />}
    <Card className="m-3 px-2 pt-2" style={headerStyle}>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div
          className="d-flex  align-items-center"
          style={{ gap: '45px' }}
        >
          <div
            className="d-flex align-items-center justify-content-start w-100 gap-lg mt-1"
            style={{ gap: "45px" }}
          >
            {TABS.map(({ key, label }) => {
              const isActive = selectedTab === key;
              return (
                <div
                  key={key}
                  style={tabStyle}
                  className={isActive ? " large-bold color-dark" : "regular-large color-grey-60"}
                  onClick={() => {
                    getOutstandingList({ tabKey: key, filters: {} });
                  }}
                >
                  {label}
                  {isActive && <div style={bottomBorder} />}
                </div>
              );
            })}
          </div>
        </div>

        <Filters
          dropdowns={dropdownData}
          getOutstandingList={getOutstandingList}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          searchInputOptions={inputFilters}
          tabKey={selectedTab}
          userPermissions={userPermissions}
        />
      </div>

      <ListComponent
        getOutstandingList={getOutstandingList}
        rows={outstandingList}
        handleContactDetailsOpen={handleContactDetailsOpen}
        setDialogOpen={setDialogOpen}
        paginationInfo={paginationInfo}
        setEditingRow={setEditingRow}
        tabKey={selectedTab}
      />

      <ContactDetailDialog
        open={showModelInfo}
        handleClose={() => setShowModelInfo(false)}
        contactDetails={showModelInfo || {}}
      />

    </Card>

    <ReminderDialog
      open={dialogOpen}
      initialRemarks={editingRow ? dialogOpen?.remarks : ''}
      initialReminderDate={editingRow ? dialogOpen?.reminderDate : null}
      onClose={handleCloseDialog}
      onSave={handleSaveRemarks}
      userPermissions={userPermissions}
    />
  </>
  );
};


export default OutstandingListingWrapper;
